module.exports = __webpack_public_path__ + "img/1002.eb6a234f.png";